module.exports = __webpack_public_path__ + "flexslider-icon.10e8a5455c4522c48aa9.svg";


//////////////////
// WEBPACK FOOTER
// /var/www/html/prod/resources/assets/frontend/~/flexslider/fonts/flexslider-icon.svg
// module id = ../../../../flexslider/fonts/flexslider-icon.svg
// module chunks = 29